import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-layout',
  templateUrl: './ui-layout.component.html',
  styleUrls: ['./ui-layout.component.css']
})
export class UILayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
